module.exports = __webpack_public_path__ + "static/the-illustrated-brief-history-of-time-ec53efaff46a7ded2fd63f1246d6cfc9.jpg";